import React, { useState, useEffect } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Button,
  makeStyles,
  Container,
  Divider,
  CardContent,
  CardHeader,
  Grid,
  TextField,
  MenuItem,
  InputLabel,
  Tooltip,
  Chip
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate, useParams } from 'react-router-dom';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { Formik, validateYupSchema } from 'formik';
import * as Yup from 'yup';
import CSVReader from 'react-csv-reader';
import { confirmAlert } from 'react-confirm-alert';
import MaterialTable from 'material-table';
import { Fragment } from 'react';
import { LoadingComponent } from '../../../utils/newLoader';
import tokenDecoder from '../../../utils/tokenDecoder';
import { useAlert } from 'react-alert';
import moment from 'moment';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  row: {
    marginTop: '1rem'
  }
}));

const screenCode = 'CUSTOMERBULKUPLOAD';
export default function CutomerBulkUpload(props) {
  const [title, setTitle] = useState('Customer Bulk Upload');
  const classes = useStyles();
  const alert = useAlert();
  const [groups, setGroups] = useState();
  const [factories, setFactories] = useState();
  const [routes, setRoutes] = useState();
  const [customerData, setcustomerData] = useState([]);
  const [isDisableButton, setIsDisableButton] = useState(false);
  const [IsUploadingFinished, setIsUploadingFinished] = useState(false);
  const [customerBulkUpload, setCustomerBulkUpload] = useState({
    groupID: '0',
    factoryID: '0',
    routeID: '0'
  });
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });
  const [ErrorCustomerCount, setErrorCustomerCount] = useState([])
  const [isUploading, setIsUploading] = useState(false);
  const handleClose = () => {
    setIsDisableButton(false);
    setOpen(false);
  };
  const [open, setOpen] = React.useState(true);
  const papaparseOptions = {
    header: true,
    dynamicTyping: false,
    quoteChar: '"',
    skipEmptyLines: true,
    parseNumbers: true,
    transformHeader: header =>
      header
        .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
          return index === 0 ? word.toLowerCase() : word.toUpperCase();
        })
        .replace(/\s+/g, '')
  };
  const navigate = useNavigate();

  useEffect(() => {
    trackPromise(getGroupsForDropdown(), getPermission());
  }, []);

  useEffect(() => {
    trackPromise(getFactoriesForDropDown());
  }, [customerBulkUpload.groupID]);

  useEffect(() => {
    trackPromise(getRoutesByFactoryID());
  }, [customerBulkUpload.factoryID]);

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(
      p => p.permissionCode == 'VIEWCUSTOMERBULKUPLOAD'
    );

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(
      p => p.permissionCode == 'GROUPDROPDOWN'
    );
    var isFactoryFilterEnabled = permissions.find(
      p => p.permissionCode == 'FACTORYDROPDOWN'
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
    });

    setCustomerBulkUpload({
      ...customerBulkUpload,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    });
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroups(groups);
  }
  async function getFactoriesForDropDown() {
    const factory = await services.getFactoryByGroupID(
      customerBulkUpload.groupID
    );
    setFactories(factory);
  }

  async function getRoutesByFactoryID() {
    const route = await services.getRoutesForDropDown(
      customerBulkUpload.factoryID
    );
    setRoutes(route);
  }

  const handleForce = (data, fileInfo) => {
    if (fileInfo.type !== 'text/csv') {
      alert.error('Wrong file format');
      clearScreen();
      return;
    }

    const eqSet = (xs, ys) =>
      xs.size === ys.size && [...xs].every(x => ys.has(x));

    const columnDetails = new Set(
      data.reduce((keys, object) => keys.concat(Object.keys(object)), [])
    );
    const concreteModel = new Set([
      'customerCode',
      'registrationNumber',
      'nic',
      'firstName',
      'lastName',
      'address',
      'addresstwo',
      'addressthree',
      'mobile',
      'home',
      'paymentTypeID',
      'accountHolderName',
      'bankID',
      'branchID',
      'accountNumber',
      'accountTypeID',
      'dob',
      'gender',
      'title',
      'joiningDate'
    ]);

    if (!eqSet(columnDetails, concreteModel)) {
      alert.error('Please upload only customer details document');
      clearScreen();
      return;
    }

    if (customerBulkUpload.routeID <= 0) {
      alert.error('Please select a route');
      clearScreen();
      return;
    } else {
      if (customerData.length > 0) {
        confirmAlert({
          title: 'Confirmation Message',
          message:
            'Are you sure to browse a new file without uploading existing file.',
          buttons: [
            {
              label: 'Yes',
              onClick: () => confirmUpload(data, fileInfo)
            },
            {
              label: 'No',
              onClick: () => handleClose()
            }
          ],
          closeOnEscape: true,
          closeOnClickOutside: true
        });
      } else {
        confirmUpload(data, fileInfo);
      }
    }
  };

  function confirmUpload(data, fileInfo) {
    setIsUploadingFinished(false);
    
    const processedData = data.map(x => {
      let nicValue = x.nic || '';
      
      if (typeof nicValue === 'string' && nicValue.includes('E')) {
        try {
          nicValue = parseFloat(nicValue).toString();
          
          if (nicValue.includes('.')) {
            nicValue = nicValue.split('.')[0];
          }
        } catch (error) {
          console.error('Error converting NIC from scientific notation:', error);
        }
      }
      
      nicValue = nicValue.toString().trim();
      
      const paymentTypeID = parseInt(x.paymentTypeID) || 0;
      const title = parseInt(x.title) || 0;
      const gender = parseInt(x.gender) || 0;
      const bankID = parseInt(x.bankID) || 0;
      const branchID = parseInt(x.branchID) || 0;
      const accountTypeID = parseInt(x.accountTypeID) || 0;
      
      let dob = x.dob || '';
      let joiningDate = x.joiningDate || '';
      
      return {
        ...x,
        nic: nicValue,
        paymentTypeID,
        title,
        gender,
        bankID,
        branchID,
        accountTypeID,
        dob,
        joiningDate,
        customerCode: (x.customerCode || '').toString().trim(),
        firstName: (x.firstName || '').toString().trim(),
        lastName: (x.lastName || '').toString().trim(),
        registrationNumber: (x.registrationNumber || '').toString().trim(),
        accountHolderName: (x.accountHolderName || '').toString().trim(),
        accountNumber: (x.accountNumber || '').toString().trim()
      };
    });

    let accountDetailsErrorCustomer = processedData.filter((customer) => {
      if (customer.paymentTypeID === 1 && (customer.bankID === 0 || 
          customer.branchID === 0 || 
          customer.accountNumber === "" || 
          customer.accountHolderName === "")) {
        return customer;
      }
    });
    
    if (accountDetailsErrorCustomer.length > 0) {
      alert.error("If the Customer Payment type is Account, Please enter other Bank Account Details");
    }

    const filteredArray = processedData.filter((customer) => {
      return (
        customer.customerCode !== "\n" && customer.customerCode !== ""
      );
    });
    
    setcustomerData(filteredArray);
  }

  function isValidNIC(nic) {
    if (!nic || nic.toString().trim() === '') return false;
    
    let nicStr = nic.toString().trim();
    
    if (nicStr.includes('E')) {
      try {
        nicStr = parseFloat(nicStr).toString();
        if (nicStr.includes('.')) {
          nicStr = nicStr.split('.')[0];
        }
      } catch (error) {
        return false;
      }
    }
    
    nicStr = nicStr.replace(/[-\s]/g, '');
    
    if (nicStr.length === 10) {
      const first9 = nicStr.substring(0, 9);
      const lastChar = nicStr.charAt(9).toUpperCase();
      return /^\d{9}$/.test(first9) && /^[VX]$/.test(lastChar);
    } else if (nicStr.length === 12) {
      return /^\d{12}$/.test(nicStr);
    } else if (nicStr.length === 9) {
      return /^\d{9}$/.test(nicStr);
    } else if (nicStr.length === 11) {
      return /^\d{11}$/.test(nicStr);
    }
    return false;
  }

  async function saveCustomer() {
    setIsUploading(true);
    let errorCustomerList = [];
    let successfulCustomers = 0;
    let failedCustomers = 0;
    var format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
    
    for (const data of customerData) {
      let hasError = false;
      let errorMessages = [];
      
      var regnumberDuplicateCount = customerData.filter(a => a.registrationNumber === data.registrationNumber).length;
      if (regnumberDuplicateCount > 1) {
        hasError = true;
        errorMessages.push('Duplicate Registration Number');
      }
      if (isNaN(data.paymentTypeID) || data.paymentTypeID > 3 || data.paymentTypeID < 1) {
        hasError = true;
        errorMessages.push('Invalid Payment Type');
      }
      if (!data.customerCode || data.customerCode.trim() === "") {
        hasError = true;
        errorMessages.push('Customer Code is Required');
      }
      if (!data.registrationNumber || data.registrationNumber.trim().length === 0 || 
           format.test(data.registrationNumber)) {
        hasError = true;
        errorMessages.push('Invalid Registration Number');
      }
      if (!isValidNIC(data.nic)) {
        hasError = true;
        errorMessages.push('Invalid NIC format');
      }
      if (!data.firstName || data.firstName.trim() === "") {
        hasError = true;
        errorMessages.push('First Name is Required');
      }
      if (data.paymentTypeID === 1) {
        if (!data.accountHolderName || data.accountHolderName.trim() === "" ||
            !data.accountNumber || data.accountNumber.trim() === "" ||
            !data.bankID || data.bankID === 0 ||
            !data.branchID || data.branchID === 0) {
          hasError = true;
          errorMessages.push('Incomplete Account Details');
        }
      }
      
      if (hasError) {
        errorCustomerList.push({...data, errorMessages: errorMessages.join(', ')});
        failedCustomers++;
        continue;
      }

      try {
        let processedNIC = data.nic.toString().trim();
        if (processedNIC.includes('E')) {
          try {
            processedNIC = parseFloat(processedNIC).toString();
            if (processedNIC.includes('.')) {
              processedNIC = processedNIC.split('.')[0];
            }
          } catch (error) {
            console.error('Error processing NIC:', error);
          }
        }
        
        let saveModel = {
          customerID: 0,
          groupID: parseInt(customerBulkUpload.groupID),
          factoryID: parseInt(customerBulkUpload.factoryID),
          routeID: parseInt(customerBulkUpload.routeID),
          customerCode: data.customerCode,
          dob: data.dob === "" || data.dob === null ? null : moment(new Date(data.dob)).format('YYYY-MM-DD'),
          firstName: data.firstName,
          home: data.home || "",
          lastName: data.lastName || "",
          mobile: data.mobile || "",
          nic: processedNIC, 
          title: parseInt(data.title) || 0,
          gender: parseInt(data.gender) || 0,
          address: data.address || "",
          addresstwo: data.addresstwo || "",
          addressthree: data.addressthree || "",
          customerBulkUploadCropBookModels: {
            customerAccountID: 0,
            routeID: parseInt(customerBulkUpload.routeID),
            accountTypeID: data.accountTypeID ? data.accountTypeID.toString() : "0",
            registrationNumber: data.registrationNumber || "",
            isDefault: true,
            isActive: true,
            createdBy: tokenDecoder.getUserIDFromToken(),
            createdDate: new Date().toISOString(),
            modifiedBy: 0,
            modifiedDate: new Date().toISOString(),
            disbursmentType: parseInt(data.paymentTypeID) || 0,
            bankID: parseInt(data.bankID) || 0,
            branchID: parseInt(data.branchID) || 0,
            accountNumber: data.accountNumber || "",
            accountHolderName: data.accountHolderName || "",
            customerPaymentMethodID: 0
          },
          createdBy: tokenDecoder.getUserIDFromToken(),
          createdDate: new Date().toISOString(),
          modifiedBy: 0,
          modifiedDate: new Date().toISOString(),
          isActive: true,
          joiningDate: data.joiningDate ? moment(new Date(data.joiningDate)).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
        };

        let response = await services.saveCustomer(saveModel);
        if (response.statusCode === 'Success') {
          successfulCustomers++;
        } else {
          errorCustomerList.push({...data, errorMessages: response.message || 'Save failed'});
          failedCustomers++;
        }
      } catch (error) {
        console.error('Error saving customer:', error);
        errorCustomerList.push({...data, errorMessages: 'Server error'});
        failedCustomers++;
      }
    }

    setErrorCustomerCount(errorCustomerList);
    setcustomerData(errorCustomerList);
    setIsUploadingFinished(true);
    setIsUploading(false);

    if (errorCustomerList.length === 0) {
      clearScreen();
      clearData();
      alert.success(`All ${successfulCustomers} customer details uploaded successfully`);
    } else {
      document.querySelector('.csv-input').value = '';
      alert.info(`${successfulCustomers} record(s) uploaded successfully and ${failedCustomers} record(s) failed`);
    }
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    );
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value;
    setCustomerBulkUpload({
      ...customerBulkUpload,
      [e.target.name]: value
    });
    clearScreen();
  }

  function clearScreen() {
    setcustomerData([]);
    const csvInput = document.querySelector('.csv-input');
    if (csvInput) csvInput.value = '';
  }

  function clearData() {
    setIsUploadingFinished(false);
    setCustomerBulkUpload({
      ...customerBulkUpload,
      routeID: '0'
    });
    setcustomerData([]);
    setErrorCustomerCount([]);
  }

  async function clearForm() {
    await trackPromise(saveCustomer());
  }

  function getNICError(nicValue) {
    if (!nicValue || nicValue.toString().trim() === '') return 'NIC is required';
    
    let processedNIC = nicValue.toString().trim();
    
    if (processedNIC.includes('E')) {
      try {
        processedNIC = parseFloat(processedNIC).toString();
        if (processedNIC.includes('.')) {
          processedNIC = processedNIC.split('.')[0];
        }
      } catch (error) {
        return 'Invalid NIC format';
      }
    }
    
    processedNIC = processedNIC.replace(/[-\s]/g, '');
    
    if (!isValidNIC(processedNIC)) {
      return 'Invalid NIC format. Use 9 digits (with or without V/X) or 12 digits';
    }
    return null;
  }

  function formatNICForDisplay(nicValue) {
    if (!nicValue) return '';
    
    let nicStr = nicValue.toString().trim();
    
    if (nicStr.includes('E')) {
      try {
        nicStr = parseFloat(nicStr).toString();
        if (nicStr.includes('.')) {
          nicStr = nicStr.split('.')[0];
        }
      } catch (error) {
        return nicValue;
      }
    }
    
    return nicStr;
  }

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: customerBulkUpload.groupID,
              factoryID: customerBulkUpload.factoryID,
              routeID: customerBulkUpload.routeID
            }}
            validationSchema={Yup.object().shape({
              groupID: Yup.number()
                .required('Group is required')
                .min('1', 'Group is required'),
              factoryID: Yup.number()
                .required('Factory is required')
                .min('1', 'Factory is required'),
              routeID: Yup.number()
                .required('Route is required')
                .min('1', 'Route is required')
            })}
            enableReinitialize
          >
            {({ errors, handleBlur, handleSubmit, touched }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={cardTitle(title)} />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              size="small"
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={e => handleChange(e)}
                              value={customerBulkUpload.groupID}
                              variant="outlined"
                              id="groupID"
                              InputProps={{
                                readOnly: !permissionList.isGroupFilterEnabled
                              }}
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(groups)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(
                                touched.factoryID && errors.factoryID
                              )}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              size="small"
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={e => handleChange(e)}
                              value={customerBulkUpload.factoryID}
                              variant="outlined"
                              id="factoryID"
                              InputProps={{
                                readOnly: !permissionList.isFactoryFilterEnabled
                              }}
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(factories)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="routeID">
                              Route *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(touched.routeID && errors.routeID)}
                              fullWidth
                              helperText={touched.routeID && errors.routeID}
                              size="small"
                              name="routeID"
                              onBlur={handleBlur}
                              onChange={e => handleChange(e)}
                              value={customerBulkUpload.routeID}
                              variant="outlined"
                              id="routeID"
                            >
                              <MenuItem value="0">--Select Routes--</MenuItem>
                              {generateDropDownMenu(routes)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={12}>
                            <InputLabel shrink>Select File *</InputLabel>
                            <CSVReader
                              cssClass="react-csv-input"
                              onFileLoaded={handleForce}
                              parserOptions={papaparseOptions}
                              inputId="react-csv-reader-input"
                            />
                          </Grid>
                        </Grid>

                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            type="reset"
                            variant="outlined"
                            onClick={() => clearData()}
                            size="small"
                          >
                            Clear
                          </Button>
                        </Box>
                        
                        {customerData.length > 0 && IsUploadingFinished === true && (
                          <>
                            <Chip 
                              variant="outlined" 
                              style={{ color: "red" }} 
                              size="small" 
                              label={`Failed Records: ${ErrorCustomerCount.length}`} 
                            />
                          </>
                        )}
                        
                        {isUploading && (
                          <Chip 
                            variant="outlined" 
                            style={{ color: "blue", marginLeft: '10px' }} 
                            size="small" 
                            label="Uploading..." 
                          />
                        )}
                        
                        <br />
                        <Box minWidth={1050}>
                          {customerData.length > 0 ? (
                            <MaterialTable
                              title="Multiple Actions Preview"
                              columns={[
                                {
                                  title: 'Customer Code',
                                  field: 'customerCode',
                                  render: rowData => {
                                    if (!rowData.customerCode || rowData.customerCode.trim() === "") {
                                      return (
                                        <div
                                          style={{
                                            backgroundColor: '#ffcdd2',
                                            padding: '10px',
                                            borderRadius: '5px'
                                          }}
                                        >
                                          <Tooltip
                                            title={rowData.errorMessages || 'Customer Code is Required'}
                                          >
                                            <span>
                                              {rowData.errorMessages || 'Customer Code is Required'}
                                            </span>
                                          </Tooltip>
                                        </div>
                                      );
                                    } else {
                                      return rowData.customerCode;
                                    }
                                  }
                                },
                                {
                                  title: 'First Name',
                                  field: 'firstName',
                                  render: rowData => {
                                    if (!rowData.firstName || rowData.firstName.trim() === "") {
                                      return (
                                        <div
                                          style={{
                                            backgroundColor: '#ffcdd2',
                                            padding: '10px',
                                            borderRadius: '5px'
                                          }}
                                        >
                                          <Tooltip title={rowData.errorMessages || 'Name is Required'}>
                                            <span>{rowData.errorMessages || 'Name is Required'}</span>
                                          </Tooltip>
                                        </div>
                                      );
                                    } else {
                                      return rowData.firstName;
                                    }
                                  }
                                },
                                {
                                  title: 'NIC',
                                  field: 'nic',
                                  render: rowData => {
                                    const formattedNIC = formatNICForDisplay(rowData.nic);
                                    const nicError = getNICError(rowData.nic);
                                    const duplicateCount = customerData.filter(a => a.nic === rowData.nic).length;
                                    
                                    if (nicError) {
                                      return (
                                        <div
                                          style={{
                                            backgroundColor: '#ffcdd2',
                                            padding: '10px',
                                            borderRadius: '5px'
                                          }}
                                        >
                                          <Tooltip title={rowData.errorMessages || nicError}>
                                            <span>{rowData.errorMessages || nicError}</span>
                                          </Tooltip>
                                        </div>
                                      );
                                    } else if (duplicateCount > 1) {
                                      return (
                                        <div
                                          style={{
                                            backgroundColor: '#ffcdd2',
                                            padding: '10px',
                                            borderRadius: '5px'
                                          }}
                                        >
                                          <Tooltip title={'Duplicate NIC.'}>
                                            <span>{'Duplicate NIC.'}</span>
                                          </Tooltip>
                                        </div>
                                      );
                                    } else {
                                      return formattedNIC;
                                    }
                                  }
                                },
                                {
                                  title: 'Registration Number',
                                  field: 'registrationNumber',
                                  render: rowData => {
                                    var result = customerData.filter(
                                      a =>
                                        a.registrationNumber ===
                                        rowData.registrationNumber
                                    );
                                    var format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
                                    if (result.length > 1) {
                                      return (
                                        <div
                                          style={{
                                            backgroundColor: '#ffcdd2',
                                            padding: '10px',
                                            borderRadius: '5px'
                                          }}
                                        >
                                          <Tooltip
                                            title={rowData.errorMessages || 'Duplicate Registration Number.'}
                                          >
                                            <span>
                                              {rowData.errorMessages || 'Duplicate Registration Number.'}
                                            </span>
                                          </Tooltip>
                                        </div>
                                      );
                                    } else if (
                                      !rowData.registrationNumber || 
                                      rowData.registrationNumber.trim().length === 0 ||
                                      format.test(rowData.registrationNumber)
                                    ) {
                                      return (
                                        <div
                                          style={{
                                            backgroundColor: '#ffcdd2',
                                            padding: '10px',
                                            borderRadius: '5px'
                                          }}
                                        >
                                          <Tooltip
                                            title={rowData.errorMessages || 'Invalid Registration Number.'}
                                          >
                                            <span>
                                              {rowData.errorMessages || 'Invalid Registration Number.'}
                                            </span>
                                          </Tooltip>
                                        </div>
                                      );
                                    } else {
                                      return rowData.registrationNumber;
                                    }
                                  }
                                },
                                {
                                  title: 'Payment Type',
                                  field: 'paymentTypeID',
                                  render: rowData => {
                                    if (isNaN(rowData.paymentTypeID) || rowData.paymentTypeID === 0) {
                                      return (
                                        <div
                                          style={{
                                            backgroundColor: '#ffcdd2',
                                            padding: '10px',
                                            borderRadius: '5px'
                                          }}
                                        >
                                          <Tooltip
                                            title={rowData.errorMessages || 'Payment Type is Required.'}
                                          >
                                            <span>
                                              {rowData.errorMessages || 'Payment Type is Required.'}
                                            </span>
                                          </Tooltip>
                                        </div>
                                      );
                                    }
                                    else if (rowData.paymentTypeID > 3 || rowData.paymentTypeID < 1) {
                                      return (
                                        <div
                                          style={{
                                            backgroundColor: '#ffcdd2',
                                            padding: '10px',
                                            borderRadius: '5px'
                                          }}
                                        >
                                          <Tooltip
                                            title={rowData.errorMessages || 'Invalid Payment Type.'}
                                          >
                                            <span>
                                              {rowData.errorMessages || 'Invalid Payment Type.'}
                                            </span>
                                          </Tooltip>
                                        </div>
                                      );
                                    } else {
                                      const paymentTypes = {
                                        1: 'Account',
                                        2: 'Cheque',
                                        3: 'Cash'
                                      };
                                      return paymentTypes[rowData.paymentTypeID] || 'Unknown';
                                    }
                                  }
                                }
                              ]}
                              data={customerData}
                              options={{
                                exportButton: false,
                                showTitle: false,
                                headerStyle: {
                                  textAlign: 'left',
                                  height: '1%'
                                },
                                cellStyle: { textAlign: 'left' },
                                columnResizable: false,
                                actionsColumnIndex: -1,
                                pageSize: 10
                              }}
                              actions={[]}
                            />
                          ) : null}
                        </Box>
                        
                        {customerData.length > 0 && !isUploading ? (
                          <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                              color="primary"
                              type="button"
                              variant="contained"
                              onClick={() => trackPromise(saveCustomer())}
                              disabled={isUploading}
                            >
                              {isUploading ? 'Uploading...' : 'Upload'}
                            </Button>
                          </Box>
                        ) : null}
                      </CardContent>
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}
